






























import Vue from "vue";
import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import './login.less';
import {Validations} from 'vuelidate-property-decorators';
import { required,email } from 'vuelidate/lib/validators';

import {submitForm} from '../../service/webclient/webclient';

import Simplemodal from '../simplemodal/simplemodal.vue';
import NewPassword from '../simplemodal/newpassword.vue';

import $ from 'jquery';

declare let window;



@Component({
  components: {
    Simplemodal,
    NewPassword
  }
})

export default class Login extends Vue {
  @Prop({
    type: String,
    default: 'simple', //simple | codecheck
  }) loginType;

  private email= '';
  private password= '';
  private modalData={
    title : 'Title',
    content: '',
    key: 'loginModal'
  };

  private titles={
    error:'Bejelentkezés',
    newpwd: 'Új jelszó igénylése'
  };
  private mesages={
    loginError: 'Sikertelen bejelentkezés! Kérjük ellenőrizze bejelentkezési adatait!',
    newpwdError: 'A megadott e-mail nem található adatbázisunkban!',
    newpwdSuccess: 'Köszönjük! A jelszó átállításához szükséges adatokat a megadott e-mail címre továbbítottuk. Kérjük ellenőrizze postafiókját!',
  };
  
  mounted() {
    let self = this;
    if(typeof window.pwdUpdateMessage !== 'undefined' && window.pwdUpdateMessage.length > 0){
        self.modalData.title='Jelszóváltoztatás';
          self.modalData.content=window.pwdUpdateMessage;
          $('#'+self.modalData.key).modal('show');
    }
  }

  submit(){
    let self = this;
    (this as any).$v.$touch();
    if(!(this as any).$v.$invalid){
      submitForm('#loginForm',{email:(this as any).email,password:(this as any).password}).then((resp)=>{
        if(resp.hiba==1){
          self.modalData.title=self.titles.error;
          self.modalData.content=self.mesages.loginError;
          $('#'+self.modalData.key).modal('show');
        }
        else{
          window.location.href = 'dashboard.php';
        }
      });
    }
  }

  getNewPassword(){
    this.$refs.newpwd.show();
  }

  teszt(){
  }


  @Validations()
    validations = {
        email: {required,email},
        password: {required}
    }

  @Watch('send', {immediate: true, deep: true})
  onSendNewPassword(email){
    let self = this;
      submitForm('#newPasswordForm',{email:email}).then((resp)=>{
        if(resp.success==0){
          self.modalData.title=self.titles.newpwd;
          self.modalData.content=self.mesages.newpwdError;
          self.$refs.newpwd.hide();
          $('#'+self.modalData.key).modal('show');
        }
        else{
          self.modalData.title=self.titles.newpwd;
          self.modalData.content=self.mesages.newpwdSuccess;
          self.$refs.newpwd.hide();
          $('#'+self.modalData.key).modal('show');
        }
      });
  }
  

}
